import makeConsentCookie from './makeConsentCookie';
import { PAYSERA_CONSENT_UPDATED_EVENT } from '../config/constants';

const addSelectedCategoriesConsent = (categories) => {
    document.cookie = makeConsentCookie(categories);

    document.dispatchEvent(new CustomEvent(PAYSERA_CONSENT_UPDATED_EVENT));
};

export default addSelectedCategoriesConsent;
